module.exports = __webpack_public_path__ + "static/taito_united-60f49a844f68219134ea7beeaf7084d2.svg";